<header>
  <app-header-cmp></app-header-cmp>
</header>
<div class="app-layout" [ngClass]="routeClass">
  <router-outlet></router-outlet>
</div>
